'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styleInject = require('../../../styleInject.js');

var css_248z = ".ReturnReasonsExchange-module_shopNowWrapper__kzl-M{align-items:center;display:flex;flex-direction:column}";
var styles = {"shopNowWrapper":"ReturnReasonsExchange-module_shopNowWrapper__kzl-M"};
styleInject["default"](css_248z, '922dc9f4-92d8-43f8-8ef6-793e504fc140');

exports["default"] = styles;
